import React from "react";

import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import "./App.css";
import Login from "./Components/Login";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "./firebase";
import Chat from "./Components/Chat";

function App() {
  const [user, loading] = useAuthState(auth);
  return (
    <div className="App">
      <Router>
        {!user ? (
          <Login />
        ) : (
          <>
            <Switch>
              <Route exact path="/">
                <Chat />
              </Route>
            </Switch>
          </>
        )}
      </Router>
    </div>
  );
}

export default App;
